import { defineMessages } from 'react-intl-next';

export const i18n = defineMessages({
	// eslint-disable-next-line @atlassian/i18n/require-description
	shareButtonText: {
		id: 'share.button.text',
		defaultMessage: 'Share',
	},
});
